var map = {
	"./category-arts-design.svg": 84610,
	"./category-biography-memoir.svg": 54510,
	"./category-business.svg": 89483,
	"./category-career-success.svg": 48933,
	"./category-communication.svg": 73731,
	"./category-economics.svg": 2697,
	"./category-education.svg": 77821,
	"./category-entertainment.svg": 3989,
	"./category-entrepreneurship.svg": 79314,
	"./category-fiction.svg": 83987,
	"./category-food.svg": 90509,
	"./category-health.svg": 25771,
	"./category-history.svg": 2515,
	"./category-law.svg": 7423,
	"./category-lifestyle.svg": 48218,
	"./category-management-leadership.svg": 38020,
	"./category-marketing.svg": 35359,
	"./category-media.svg": 52339,
	"./category-money-finance.svg": 64002,
	"./category-motivation.svg": 87269,
	"./category-news.svg": 75292,
	"./category-parenting.svg": 3467,
	"./category-philosophy.svg": 17936,
	"./category-politics.svg": 8644,
	"./category-productivity.svg": 47701,
	"./category-psychology.svg": 38190,
	"./category-relationships.svg": 10934,
	"./category-sales.svg": 45975,
	"./category-science.svg": 26977,
	"./category-self-improvement.svg": 18784,
	"./category-society-culture.svg": 4652,
	"./category-spirituality.svg": 12716,
	"./category-sports.svg": 90060,
	"./category-technology.svg": 18047
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 25339;